import React, { type InputHTMLAttributes, useMemo } from "react";
import { FormattedMessage } from "react-intl";
import { Field } from "redux-form";
import InputRenderer from "src/shared/forms/formrenderers/InputRenderer";
import type IFormInputs from "src/shared/forms/inputs/IFormInputs";
import Integer from "src/shared/forms/validations/Integer";
import { length as Length } from "src/shared/forms/validations/Length";
import { NoTrailingSpaceWithMessage } from "src/shared/forms/validations/NoTrailingSpace";
import type { ValidationHandler } from "src/shared/forms/validations/ValidationHandler";

export interface IContactPhoneExtInputProps
  extends IFormInputs,
    InputHTMLAttributes<HTMLInputElement> {}

export default ({
  inputID,
  label = <FormattedMessage id="contacts.phone_ext" />,
  validationDisabled = false,
  ...rest
}: IContactPhoneExtInputProps) => {
  const validations: ValidationHandler[] = useMemo(() => {
    if (validationDisabled) {
      return undefined;
    }
    return [
      Length(0, 16),
      Integer(<FormattedMessage id="contacts.phone_ext.invalid" />),
      NoTrailingSpaceWithMessage(
        <FormattedMessage id="contacts.phone_ext.invalid" />,
      ),
    ];
  }, [validationDisabled]);
  return (
    <Field
      name={inputID}
      label={label}
      type="text"
      component={InputRenderer}
      validate={validations}
      {...rest}
    />
  );
};
